<template>
  <div>
    <transition name="fade">
      <div v-if="contact" class="contact">
        <div class="offclick" @click="contact = false"></div>
        <div class="holder">
          <div class="contact_info">
            <h3>Connect with us</h3>
            <div class="line2"></div>
            <h4>Engineering Offices</h4>
            <h5>Plummer 2-39</h5>
            <h4>Biomechanical Shop</h4>
            <h5>Medical Science SL-16</h5>
            <h4>Additive Manufacturing Facility</h4>
            <h5>Baldwin BA-410</h5>

            <h4>Phone:</h4>
            <h5>(507) 266-4552</h5>
            <h4>Visit us on the intranet:</h4>
            <h5>http://intranet.mayo.edu/charlie/ division-engineering-rst/</h5>
          </div>

          <div class="form">
            <div class="step1">
              <div class="inputs">
                <div class="input full">
                  <h5>Full Name</h5>
                  <input type="text" placeholder="Type to get started..." />
                </div>
                <div class="input full">
                  <h5>Email Address</h5>
                  <input type="email" />
                </div>
                <div class="input full">
                  <h5>Comments</h5>
                  <input type="comment" />
                </div>
                <div class="input full">
                  <button class="btn1"><p>Next Step</p></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <router-link to="/:kioskId">
      <div class="btn back"><p>Back</p></div>
    </router-link>
    <!-- <div class="btn close" @click="contact = true"><p>Contact</p></div> -->
  </div>
</template>

<script>
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");
var tz = require("moment-timezone");

export default {
  name: "heading",
  components: {},
  data() {
    return {
      cover: true,
      kiosk: null,
      kiosk_id: null,
      contact: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.params.kioskId) {
        // this.getIds();
      }
    });
  },
  created() {
    this.removeCover();
  },
  firestore() {
    return {
      kioskObjs: db.collection("kiosks")
    };
  },
  methods: {
    showCover() {
      this.cover = true;
      this.removeCover();
    },
    removeCover() {
      let vm = this;
      setTimeout(function() {
        vm.cover = false;
      }, 500);
    },
    getIds() {
      let vm = this;
      db.collection("kiosks")
        .where("slug", "==", vm.$route.params.kioskId)
        .get()
        .then(snashot => {
          vm.kiosk_id = snashot.docs[0].id;
          localStorage.setItem("id", vm.kiosk_id);
          vm.kiosk = snashot.docs[0].data();
          vm.saveLastSignal();
        });
    },
    saveLastSignal() {
      let signal = moment.tz(moment(Date.now()), "America/New_York");
      this.kiosk.lastSignal = signal.toISOString();

      db.collection("kiosks")
        .doc(this.kiosk_id)
        .set(this.kiosk, { merge: true })
        .then(snashot => {});
    }
  },
  watch: {
    $route(to, from) {
      this.removeCover();
    }
  }
};
</script>
<style scoped>
h3 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 50px;
  position: relative;
  padding-top: 0px;
  width: 500px;
  text-align: center;
  font-weight: lighter;
  letter-spacing: 5px;
  text-align: left;
  margin: 0;
}

h4 {
  font-family: AzoSans Bold;
  color: #ffffff;
  font-size: 24px;
  margin: 0;
  padding-top: 20px;
}

h5 {
  font-family: AzoSans;
  color: #ffffff;
  font-size: 24px;
  font-weight: lighter;
  margin: 0;
}

.line2 {
  position: relative;
  height: 8px;
  width: 100px;
  background-color: blue;
  margin-bottom: 20px;
}

.btn1 {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 10px;
  border: 0;
  margin-top: 10px;
}

.btn1 p {
  color: #ffffff;
  padding: 10px 10px !important;
  font-family: AzoSans;
  font-size: 25px;
  margin: 0;
}
</style>
